import { useFormik } from "formik";
import { toast } from "react-toastify";

// Components
import { Heading2 } from "../../../../../components/typography";
import { Header, Body, Button } from "../../../../../components/UI";
import ServiceForm from "../ServiceForm/ServiceForm";

// Icons
import { Close } from "../../../../../SVGS";

// Builders
import * as buttonDesignType from "../../../../../builders/buttonDesign.types";

// Form Models
import { ServiceMenuFormModel } from "../../../../../models/app/forms";

// Calls
import { updateServiceMenuRequest } from "../../../../../api/calls/general-branch-settings.call";

// Services
import { serviceValidation } from "../../../../../services/validations/service.validation";

// Styles
import { EditServiceStyles } from "./editService.styles";

const EditService = ({
  closeModal,
  chosenService,
  branchId,
  setServiceMenuStateAfterCreateOrEdit
}) => {
  const initialValues = new ServiceMenuFormModel(
    chosenService.generateServiceForm()
  );
  const updateServiceHandler = async values => {
    const response = await updateServiceMenuRequest(
      branchId,
      values,
      initialValues,
      chosenService.id
    );
    if (response.hasError) {
      toast.error(response.error.message);
      return;
    }
    toast.success("Service item successfully updated.");
    setServiceMenuStateAfterCreateOrEdit(response.serviceMenu);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    onSubmit: updateServiceHandler,
    validate: serviceValidation
  });

  const {
    values,
    touched,
    errors,
    dirty,
    handleSubmit,
    setFieldValue,
    setFieldTouched,
    handleBlur,
    handleChange
  } = formik;

  return (
    <EditServiceStyles>
      <form autoComplete="new-password" onSubmit={handleSubmit}>
        <Header className="formHeader">
          <Heading2>EDIT SERVICE ITEM</Heading2>
          <div className="headerActions">
            {dirty && (
              <Button type="submit" buttonDesignType={buttonDesignType.PRIMARY}>
                Save Changes
              </Button>
            )}
            <Close onClick={closeModal} />
          </div>
        </Header>
        <Body>
          <ServiceForm
            values={values}
            touched={touched}
            errors={errors}
            setFieldValue={setFieldValue}
            setFieldTouched={setFieldTouched}
            handleBlur={handleBlur}
            handleChange={handleChange}
            hideButton
          />
        </Body>
      </form>
    </EditServiceStyles>
  );
};

export default EditService;
